import { Link } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

export function NotFoundPage() {
  const { me } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <main id="main" className="card w-full max-w-md p-7 text-center">
        <p className="font-mono text-sm text-muted">404</p>
        <h1 className="mt-1 text-base font-semibold text-ink">We couldn&rsquo;t find that page</h1>
        <p className="mt-2 text-sm text-muted">
          The link may be out of date, or the page may have moved.
        </p>
        <Link to={me ? me.landingPath : '/login'} className="btn-primary mt-5">
          {me ? 'Back to Ambition' : 'Go to sign in'}
        </Link>
      </main>
    </div>
  );
}
